import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../../views/login/Login.vue'
import setPassword from '../../views/login/setPassword.vue'
import forgotPassword from '../../views/login/forgotPassword.vue'

Vue.use(VueRouter)

const Login = [
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/setPassword',
        name: 'SetPassword',
        component: setPassword
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        component: forgotPassword
    },

]

export default Login
